(function () {
  'use strict';

  var RATES = [[15, 10], [20, 10], [22, 10]];
  var ONE_TIME_RATES = [0, 5, 7];

  function validId(value) {
    var text = String(value || '');
    return /^[1-9]\d*$/.test(text) ? text : null;
  }

  function integer(value) {
    return Number.isInteger(value) && value > 0;
  }

  function formatPrice(cents) {
    return (cents / 100).toLocaleString('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function singleVariant(product) {
    var variants = product && Array.isArray(product.variants)
      ? product.variants.filter(function (variant) { return variant.available; })
      : [];
    if (variants.length !== 1 || !integer(variants[0].id) || !integer(variants[0].price)) {
      throw new Error('Produit indisponible');
    }
    return variants[0];
  }

  function planFor(product, quantity) {
    var rates = RATES[quantity - 1];
    var groupName = quantity + ' personne' + (quantity === 1 ? '' : 's');
    var groups = Array.isArray(product.selling_plan_groups)
      ? product.selling_plan_groups.filter(function (group) {
        return group.app_id === 'appstle' && group.name === groupName;
      })
      : [];
    if (groups.length !== 1) throw new Error('Plan abonnement indisponible');
    var plans = Array.isArray(groups[0].selling_plans)
      ? groups[0].selling_plans.filter(function (plan) { return plan.name === 'Tous les 2 mois'; })
      : [];
    if (plans.length !== 1) throw new Error('Plan abonnement indisponible');
    var plan = plans[0];
    var adjustments = plan.price_adjustments;
    if (!integer(plan.id) || plan.recurring_deliveries !== true || !Array.isArray(adjustments) ||
        adjustments.length !== 2 || adjustments[0].order_count !== 1 ||
        adjustments[0].value_type !== 'percentage' || adjustments[0].value !== rates[0] ||
        adjustments[1].order_count !== null || adjustments[1].value_type !== 'percentage' ||
        adjustments[1].value !== rates[1]) {
      throw new Error('Plan abonnement obsolète');
    }
    return { id: plan.id, firstRate: rates[0], renewalRate: rates[1] };
  }

  function allocationFor(variant, plan) {
    var allocations = Array.isArray(variant.selling_plan_allocations)
      ? variant.selling_plan_allocations.filter(function (allocation) {
        return allocation.selling_plan_id === plan.id;
      })
      : [];
    if (allocations.length !== 1) throw new Error('Tarif abonnement indisponible');
    var allocation = allocations[0];
    var adjustments = allocation.price_adjustments;
    var expectedFirst = Math.round(variant.price * (100 - plan.firstRate) / 100);
    var expectedRenewal = Math.round(variant.price * (100 - plan.renewalRate) / 100);
    if (allocation.price !== expectedFirst || allocation.per_delivery_price !== expectedFirst ||
        !Array.isArray(adjustments) || adjustments.length !== 2 ||
        adjustments[0].position !== 1 || adjustments[0].price !== expectedFirst ||
        adjustments[1].position !== 2 || adjustments[1].price !== expectedRenewal) {
      throw new Error('Tarif abonnement obsolète');
    }
    return { first: allocation.price, renewal: adjustments[1].price };
  }

  function buildPricing(product, quantity, subscribed) {
    if ([1, 2, 3].indexOf(quantity) === -1) throw new RangeError('Quantité invalide');
    var variant = singleVariant(product);
    if (!subscribed) {
      var perBottle = Math.round(variant.price * (100 - ONE_TIME_RATES[quantity - 1]) / 100);
      return {
        total: perBottle * quantity,
        renewal: perBottle * quantity,
        perBottle: perBottle,
        sellingPlanId: null
      };
    }
    var plan = planFor(product, quantity);
    var allocation = allocationFor(variant, plan);
    return {
      total: allocation.first * quantity,
      renewal: allocation.renewal * quantity,
      perBottle: allocation.first,
      sellingPlanId: String(plan.id)
    };
  }

  function buildSubmissionState(quantity, subscribed, variantId, sellingPlanId, buyable) {
    if ([1, 2, 3].indexOf(quantity) === -1) throw new RangeError('Quantité invalide');
    var normalizedVariantId = validId(variantId);
    var normalizedSellingPlanId = validId(sellingPlanId);
    return {
      valid: Boolean(buyable && normalizedVariantId && (!subscribed || normalizedSellingPlanId)),
      quantity: quantity,
      variantId: normalizedVariantId,
      sellingPlanId: subscribed ? normalizedSellingPlanId : null
    };
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      buildPricing: buildPricing,
      buildSubmissionState: buildSubmissionState,
      formatPrice: formatPrice
    };
  }

  if (typeof document === 'undefined') return;

  function route(win, path) {
    var base = win.Shopify && win.Shopify.routes && win.Shopify.routes.root;
    if (typeof base !== 'string' || !/^\/(?!\/)/.test(base)) throw new Error('Route Shopify invalide');
    return base.replace(/\/$/, '') + '/' + path;
  }

  function setupOffer(offer, win) {
    var form = offer.querySelector('[data-veji-offer-form]');
    var quantityInputs = offer.querySelectorAll('[data-quantity]');
    var subscriptionOption = offer.querySelector('[data-subscription-option]');
    var subscriptionToggle = offer.querySelector('[data-subscription-toggle]');
    var variantField = offer.querySelector('[data-cart-variant]');
    var quantityField = offer.querySelector('[data-cart-quantity]');
    var sellingPlanField = offer.querySelector('[data-cart-selling-plan]');
    var submitButton = offer.querySelector('[data-order-button]');
    var orderPrice = offer.querySelector('[data-order-price]');
    var orderDetail = offer.querySelector('[data-order-detail]');
    var orderRenewal = offer.querySelector('[data-order-renewal]');
    var orderPerBottle = offer.querySelector('[data-order-per-bottle]');
    var status = offer.querySelector('[data-offer-status]');

    if (!form || !quantityInputs.length || !subscriptionOption || !subscriptionToggle ||
        !variantField || !quantityField || !sellingPlanField || !submitButton ||
        !orderPrice || !orderDetail || !orderRenewal || !orderPerBottle) return;

    var variantId = variantField.value;
    var unitPrice = Number(offer.getAttribute('data-unit-price'));
    var handle = offer.getAttribute('data-product-handle');
    var buyable = offer.getAttribute('data-buyable') === 'true';
    var product = null;

    subscriptionOption.hidden = true;
    subscriptionToggle.disabled = true;

    function oneTimeFallback(quantity) {
      if (!integer(unitPrice)) throw new Error('Prix indisponible');
      var perBottle = Math.round(unitPrice * (100 - ONE_TIME_RATES[quantity - 1]) / 100);
      return {
        total: perBottle * quantity,
        renewal: perBottle * quantity,
        perBottle: perBottle,
        sellingPlanId: null
      };
    }

    function sync() {
      var selectedQuantity = offer.querySelector('[data-quantity]:checked');
      var quantity = selectedQuantity ? Number(selectedQuantity.value) : NaN;
      var subscribed = Boolean(product && subscriptionToggle.checked);
      try {
        var pricing = product ? buildPricing(product, quantity, subscribed) : oneTimeFallback(quantity);
        var state = buildSubmissionState(quantity, subscribed, variantId, pricing.sellingPlanId, buyable);
        quantityField.value = String(state.quantity);
        sellingPlanField.disabled = !state.sellingPlanId;
        sellingPlanField.value = state.sellingPlanId || '';
        submitButton.disabled = !state.valid;
        orderPrice.textContent = formatPrice(pricing.total);
        orderRenewal.hidden = !subscribed;
        orderRenewal.textContent = subscribed ? 'Puis ' + formatPrice(pricing.renewal) + '/2 mois' : '';
        orderPerBottle.textContent = formatPrice(pricing.perBottle) + '/flacon';
        offer.setAttribute('data-selected-quantity', String(state.quantity));
        offer.setAttribute('data-purchase-mode', subscribed ? 'subscription' : 'one-time');
        if (status) status.textContent = '';
      } catch (error) {
        submitButton.disabled = true;
        orderPrice.textContent = 'Indisponible';
        orderRenewal.hidden = true;
        orderRenewal.textContent = '';
        orderPerBottle.textContent = '';
        if (status) status.textContent = 'Offre indisponible. Rechargez la page.';
      }
    }

    Array.prototype.forEach.call(quantityInputs, function (input) {
      input.addEventListener('change', sync);
    });
    subscriptionToggle.addEventListener('change', sync);

    form.addEventListener('submit', function (event) {
      sync();
      if (submitButton.disabled || form.getAttribute('data-preview-only') === 'true') {
        event.preventDefault();
        if (status && form.getAttribute('data-preview-only') === 'true') {
          status.textContent = 'Aperçu local — aucun ajout au panier.';
        }
      }
    });

    sync();
    if (!/^[a-z0-9-]+$/.test(handle || '')) return;
    win.fetch(route(win, 'products/' + handle + '.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Catalogue indisponible');
      return response.json();
    }).then(function (loaded) {
      var candidate = loaded.product || loaded;
      var variant = singleVariant(candidate);
      if (String(variant.id) !== variantId) throw new Error('Variant inattendu');
      [1, 2, 3].forEach(function (quantity) { buildPricing(candidate, quantity, true); });
      product = candidate;
      subscriptionOption.hidden = false;
      subscriptionToggle.disabled = false;
      sync();
    }).catch(function () {
      product = null;
      subscriptionToggle.checked = false;
      subscriptionToggle.disabled = true;
      subscriptionOption.hidden = true;
      sync();
    });
  }

  Array.prototype.forEach.call(document.querySelectorAll('.veji-simple-offer[data-veji-offer]'), function (offer) {
    setupOffer(offer, window);
  });
}());